import { DEFAULT_LANG, isSupportedLang } from "@/lib/i18n";

export const PAGE_SLUGS = {
  home: "",
  privacy: "privacy",
  cookies: "cookies",
  terms: "terms",
};

export const THANK_YOU_PATH = "/thank_you";

export function langPath(lang, slug = "") {
  const safe = isSupportedLang(lang) ? lang : DEFAULT_LANG;
  return slug ? `/${safe}/${slug}` : `/${safe}`;
}

/** Returns the path without its language prefix, e.g. "/en/terms" -> "terms". */
export function stripLang(pathname) {
  const parts = (pathname || "").split("/").filter(Boolean);
  if (parts.length && isSupportedLang(parts[0])) return parts.slice(1).join("/");
  return parts.join("/");
}

export const HOME_SECTIONS = [
  { id: "servicio", labelKey: "nav.service" },
  { id: "como-funciona", labelKey: "nav.how" },
  { id: "ventajas", labelKey: "nav.advantages" },
  { id: "contacto", labelKey: "nav.contact" },
  { id: "faq", labelKey: "nav.faq" },
];
